export default {"src":"/_next/static/media/romania.f787162f.svg","height":38,"width":55};